import { Dialog } from "construct-ui";
import FileUploadInputComponent from "../../../../components/file/file-upload-input.component";
import { FILE_EXTENSIONS, formats as FORMATS, } from "../../../../config/constants";
import StoreFixtureMappingModel from "../../../../models/planogram/store-fixture-mapping.model";
import ViewBase from "../../../view-base.view";
import fileTemplateModel from "../../../../models/common/file-template.model"
import moment from "moment";

/**
 * Store Fixture Mapping- Excel Upload Dialog
 * 
 * The upload dialog used to download excel template and upload records to delete or update
 * 
 * @author Molly Liu
 */

export default function StoreFixtureMappingUploadDialog() {
  ViewBase.call(this);

  const FORM_ID = 'storeFixtureMappingExcelUploadForm';
  const UPLOAD_INPUT_ID = 'storeFixtureMappingExcelUploadInput';

  let file = null
  let handleCloseDialog = () => { };

  const downloadMappingTemplate = () => {
    this.showLoading();
    const File_Name = "Store_Fixture_Mapping_Template.xlsx"
    const exportConfig = {
      storedProcedureCode: "38",
      params: [
        {
          "code": "66",
          "value": "StoreFixtureMap"
        }
      ],
      excelSheetNames: ["Store Fixture Mapping"]
    };

    fileTemplateModel.downloadExcelTemplate(File_Name, exportConfig)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const upload = (e) => {
    // Form validation
    if (!this.validateForm(e)) {
      return false;
    }

    this.showLoading();
    const FILE_NAME = `Store_Fixture_Mapping_Uploaded_Result_${moment(new Date()).format(FORMATS.apiDateFormat)}`

    StoreFixtureMappingModel.uploadMapping(file, FILE_NAME)
      .then((result) => {
        // console.log("resultSotre fixture upload=====>", result)
        // downloadBlob(result, FILE_NAME)
        this.showMessage(this.getText('EM00000313', 'Upload Completed'), this.getText('EM00000004', 'Success'), () => {
          handleCloseDialog();
        })
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onClose)
      handleCloseDialog = vnode.attrs.onClose;

      // console.log('downloadBlob', downloadBlob)
    },
    view: ({ attrs: { isOpen, onClose } }) => {
      return m(Dialog,
        {
          isOpen,
          onClose,
          class: 'cui-dialog-l',
          title: this.getText('LT00001229', 'Store Mapping'),
          content: m('.row.ms-2',
            m('ol',
              m('li.fw-bold.mb-4',
                m('.mb-2', this.getText('LT00000018', 'Excel Download')),
                m('button.btn.btn-primary',
                  {
                    onclick: downloadMappingTemplate
                  },
                  m('i.bi.bi-file-earmark-arrow-down-fill'),
                  this.getText('LT00000218', 'Download Template')
                ),
              ),
              m('hr'),
              m('li.fw-bold.mb-4',
                m('.mb-2.mandatory', this.getText('LT00000197', 'Excel Upload')),
                m('form.row.g-4.needs-validation[novalidate]', { id: FORM_ID, onsubmit: upload },
                  m('.col-12.position-relative',
                    m(FileUploadInputComponent, {
                      id: UPLOAD_INPUT_ID,
                      accept: FILE_EXTENSIONS.XLSX,
                      required: true,
                      onInput: (data) => { file = data; },
                    }),
                    m('.invalid-tooltip', this.getText('EM00000316', 'Please select a file'))
                  )
                ),
              )
            ),
            this.getBaseViews()
          ),
          footer: m('.d-flex.gap-2.justify-content-end',
            m('button.btn.btn-primary[type="submit"]', { form: FORM_ID }, this.getText("LT00000290", "Upload")),
            m('button.btn.btn-white', { onclick: onClose }, this.getText("LT00000021", "Close"))
          )
        }
      );
    }
  }
}
